/**
 * Google Ads tag (gtag.js) + conversion events.
 *
 * Entirely env-gated: with REACT_APP_GOOGLE_ADS_ID unset/empty nothing
 * loads and every call is a no-op, so the site is unaffected until the
 * real AW id + conversion label are configured.
 */
const GADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const QUIZ_LABEL = process.env.REACT_APP_GOOGLE_ADS_QUIZ_LABEL;
const SIGNUP_LABEL = process.env.REACT_APP_GOOGLE_ADS_SIGNUP_LABEL;

let injected = false;

function ensureGtag() {
  if (!GADS_ID) return null;
  if (!window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
  if (!injected) {
    injected = true;
    const s = document.createElement("script");
    s.async = true;
    s.id = "google-ads-gtag";
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GADS_ID}`;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    window.gtag("config", GADS_ID);
  }
  return window.gtag;
}

export function initGoogleAds() {
  ensureGtag();
}

/** Fire the "Quiz Email Captured" conversion (Google Ads website conversion). */
export function trackQuizLeadConversion() {
  const gtag = ensureGtag();
  if (!gtag || !QUIZ_LABEL) return;
  gtag("event", "conversion", { send_to: `${GADS_ID}/${QUIZ_LABEL}` });
}

/** Fire the "Account Signup" conversion (60-day trial account created). */
export function trackSignupConversion() {
  const gtag = ensureGtag();
  if (!gtag || !SIGNUP_LABEL) return;
  gtag("event", "conversion", { send_to: `${GADS_ID}/${SIGNUP_LABEL}` });
}
